module.exports = __webpack_public_path__ + "static/media/2020.6.29赵屯居委 二居委社区工作交流.9d2345f1.jpg";